import { Outlet } from "react-router-dom";
import Header from "../Components/Header";

import Footer from "../Components/Footer";
import { useState } from "react";
import CategoriesNavbar from "../Components/CategoriesNavbar";


function WebsiteLayout() {
  // Selected category/subcategory
  const [categoryId, setCategoryId] = useState(null);
  const [subCategoryId, setSubCategoryId] = useState(null);

  return (
    <>
      <div className="top-fixed">
        <Header />
        <CategoriesNavbar 
          onCategoryClick={setCategoryId} 
          onSubCategoryClick={setSubCategoryId}
        />
       
      </div>

      <div className="main-content">
        {/* Pass selected IDs to child pages */}
        <Outlet context={{ categoryId, subCategoryId }} />
      </div>

      <Footer />
    </>
  );
}

export default WebsiteLayout;